export default __webpack_public_path__ + "static/media/top_transparency_layer.d2254adb.png";